import { useCallback, useMemo, useRef } from 'react';
import useGlobals from './useGlobals';

const useGroups = () => {
    const { handleNavigate, i18n, settings, windowWidth, getBreakpoint } = useGlobals();
    const searchInput = useRef<HTMLInputElement>(null);

    const handleEdit = useCallback(
        (identifier: string) => {
            handleNavigate(identifier);
        },
        [handleNavigate],
    );

    const GroupsActions = useMemo(
        () => ({
            handleEdit,
        }),
        [handleEdit],
    );

    return {
        GroupsActions,
        settings,
        i18n,
        searchInput,
        windowWidth,
        getBreakpoint,
        handleNavigate,
    };
};

export default useGroups;
